module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/ApplePay-3b899d7136fb80651f5d6fe8902e9e99.svg";